import { render, staticRenderFns } from "./CreateAforoDoor.vue?vue&type=template&id=04144ca7&"
import script from "./CreateAforoDoor.vue?vue&type=script&lang=js&"
export * from "./CreateAforoDoor.vue?vue&type=script&lang=js&"
import style0 from "./CreateAforoDoor.vue?vue&type=style&index=0&id=04144ca7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports